/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: iNIVOnwl5FXM

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesNavigationMenu from "../../FeaturesNavigationMenu"; // plasmic-import: P0bQ5GYC74Ng/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFeaturesNavigation.module.css"; // plasmic-import: iNIVOnwl5FXM/css

createPlasmicElementProxy;

export type PlasmicFeaturesNavigation__VariantMembers = {};
export type PlasmicFeaturesNavigation__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesNavigation__VariantsArgs;
export const PlasmicFeaturesNavigation__VariantProps =
  new Array<VariantPropType>();

export type PlasmicFeaturesNavigation__ArgsType = {
  onProductClick?: (id: string) => void;
  currentSection?: string;
  onCurrentSectionChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicFeaturesNavigation__ArgsType;
export const PlasmicFeaturesNavigation__ArgProps = new Array<ArgPropType>(
  "onProductClick",
  "currentSection",
  "onCurrentSectionChange"
);

export type PlasmicFeaturesNavigation__OverridesType = {
  root?: Flex__<"section">;
  desktopWrapper?: Flex__<"nav">;
  h5?: Flex__<"h5">;
  mobileWrapper?: Flex__<"nav">;
  featuresNavigationMenu?: Flex__<typeof FeaturesNavigationMenu>;
};

export interface DefaultFeaturesNavigationProps {
  onProductClick?: (id: string) => void;
  currentSection?: string;
  onCurrentSectionChange?: (val: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesNavigation__RenderFunc(props: {
  variants: PlasmicFeaturesNavigation__VariantsArgs;
  args: PlasmicFeaturesNavigation__ArgsType;
  overrides: PlasmicFeaturesNavigation__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "currentSection",
        type: "writable",
        variableType: "text",

        valueProp: "currentSection",
        onChangeProp: "onCurrentSectionChange"
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? false
          : hasVariant(globalVariants, "mobile", "mobile")
            ? true
            : true
      ) ? (
        <nav
          data-plasmic-name={"desktopWrapper"}
          data-plasmic-override={overrides.desktopWrapper}
          className={classNames("all", sty.desktopWrapper)}
        >
          <h5
            data-plasmic-name={"h5"}
            data-plasmic-override={overrides.h5}
            className={classNames(
              "all",
              "h5",
              "h5__bvRZj",
              "__wab_text",
              sty.h5
            )}
          >
            {"Navigate to Product"}
          </h5>
          <Logo
            className={classNames("__wab_instance", sty.logo__ubRz)}
            grayscale={(() => {
              try {
                return $state.currentSection != "MyEvaluations";
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"Navigate to MyEvaluations product"}
            interactable={true}
            onClick={async () => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyEvaluations"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }
            }}
            product={"myEvaluations"}
          />

          <Logo
            className={classNames("__wab_instance", sty.logo__nvvZx)}
            grayscale={(() => {
              try {
                return $state.currentSection != "MyCME";
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"Navigate to MyCME product"}
            interactable={true}
            onClick={async () => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyCME"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }
            }}
            product={"myCme"}
          />

          <Logo
            className={classNames("__wab_instance", sty.logo__ytBc0)}
            grayscale={(() => {
              try {
                return $state.currentSection != "MyGME";
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            hoverText={"Navigate to MyGME FISCAL product"}
            interactable={true}
            onClick={async () => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyGME"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }
            }}
            product={"myGme"}
          />
        </nav>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? true
          : hasVariant(globalVariants, "mobile", "mobile")
            ? false
            : false
      ) ? (
        <nav
          data-plasmic-name={"mobileWrapper"}
          data-plasmic-override={overrides.mobileWrapper}
          className={classNames("all", sty.mobileWrapper)}
        >
          <FeaturesNavigationMenu
            data-plasmic-name={"featuresNavigationMenu"}
            data-plasmic-override={overrides.featuresNavigationMenu}
            className={classNames("__wab_instance", sty.featuresNavigationMenu)}
            currentSection={args.currentSection}
            currentSection2={(() => {
              try {
                return (() => {
                  const section = $state.currentSection.toLowerCase();
                  return (
                    section.substring(0, 2) +
                    section.charAt(2).toUpperCase() +
                    section.substring(3)
                  );
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()}
            onProductClick={
              true
                ? args.onProductClick
                : true
                  ? args.onProductClick
                  : args.onProductClick
            }
          />
        </nav>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "desktopWrapper",
    "h5",
    "mobileWrapper",
    "featuresNavigationMenu"
  ],
  desktopWrapper: ["desktopWrapper", "h5"],
  h5: ["h5"],
  mobileWrapper: ["mobileWrapper", "featuresNavigationMenu"],
  featuresNavigationMenu: ["featuresNavigationMenu"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "section";
  desktopWrapper: "nav";
  h5: "h5";
  mobileWrapper: "nav";
  featuresNavigationMenu: typeof FeaturesNavigationMenu;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesNavigation__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesNavigation__VariantsArgs;
    args?: PlasmicFeaturesNavigation__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesNavigation__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesNavigation__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesNavigation__ArgProps,
          internalVariantPropNames: PlasmicFeaturesNavigation__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesNavigation__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFeaturesNavigation";
  } else {
    func.displayName = `PlasmicFeaturesNavigation.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesNavigation = Object.assign(
  // Top-level PlasmicFeaturesNavigation renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    desktopWrapper: makeNodeComponent("desktopWrapper"),
    h5: makeNodeComponent("h5"),
    mobileWrapper: makeNodeComponent("mobileWrapper"),
    featuresNavigationMenu: makeNodeComponent("featuresNavigationMenu"),

    // Metadata about props expected for PlasmicFeaturesNavigation
    internalVariantProps: PlasmicFeaturesNavigation__VariantProps,
    internalArgProps: PlasmicFeaturesNavigation__ArgProps
  }
);

export default PlasmicFeaturesNavigation;
/* prettier-ignore-end */
